import React, { useEffect, useState ,useRef } from "react";
import SearchSection from "../Components/SearchSection";
import MenuSection from "../Components/MenuSection";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { _get } from "../services/apiClient";
import { useSearch } from "../SearchContext";
import { IoArrowBack } from "react-icons/io5";

function Product({
  handleClick,
  cart,
  setCart,
  handleCartClick,
  restaurantStatus,
}) {
  const [products, setProducts] = useState([]);
  const [offset, setOffset] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [subCategories, setSubCategories] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const { id } = useParams();
  const [isServerSearch, setIsServerSearch] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  

  const { filtersubCategory } = useSearch();
  const { searchAllCategories, searchData } = useSearch();
  useEffect(() => {
    fetchSubCategoryData();
  }, []);

  useEffect(() => {
    goToTop();
    setOffset(1);
    setProducts([]);
    fetchData(1, true);
  }, [id, filtersubCategory]);

  useEffect(() => {
    setOffset(1);
    setProducts([]);
    fetchData(1, true);
  }, [id, filtersubCategory, searchData, searchAllCategories]);
  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 10
      ) {
        if (offset < totalPages && !isFetching) {
          setOffset((prevOffset) => prevOffset + 1);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [offset, totalPages, isFetching]);

  useEffect(() => {
    if (offset > 1) fetchData(offset, false);
  }, [offset]);

  // If a subcategory is provided in the URL (banner deep-link), try loading
  // additional pages until we find a product from that subcategory.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const subcatParam = params.get("subcat");
    if (!subcatParam) return;

    const normalize = (v) => {
      if (!v) return null;
      if (typeof v === "string") return v;
      if (typeof v === "object" && v._id) return v._id;
      if (typeof v === "object" && v.$oid) return v.$oid;
      return null;
    };

    const hasSubcat = products.some((p) => normalize(p.subcategory) === subcatParam);
    if (!hasSubcat && offset < totalPages && !isFetching) {
      setOffset((prev) => prev + 1);
    }
  }, [location.search, products, offset, totalPages, isFetching]);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const fetchData = async (page, isReset) => {
    try {
      setIsFetching(true);

      let url = "";
      let serverSearch = false;

      if (searchAllCategories && searchData) {
        url = `/products/menu?search=${searchData}&page=${page}&limit=20`;
        serverSearch = true;
      } else if (searchData && !searchAllCategories) {
        url = `/products/menu?category=${id}&search=${searchData}&page=${page}&limit=20`;
        serverSearch = true;
      } else {
        url = `/products/menu?category=${id}&page=${page}&limit=20`;
        serverSearch = false;
      }

      const response = await _get(url);

      if (isReset) {
        setProducts(response.data.products);
      } else {
        setProducts((prev) => [...prev, ...response.data.products]);
      }

      setTotalPages(response.data.totalPages);
      setIsServerSearch(serverSearch); // <-- Set the flag here
      setIsFetching(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsFetching(false);
    }
  };

  const fetchSubCategoryData = async () => {
    try {
      const response = await _get(`/subcategory`);
      setSubCategories(response.data);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-amber-50">
      <SearchSection
        handleClick={handleClick}
        catId={id}
        subCategories={subCategories}
        cart={cart}
        showBackButton={true}
      />
      <MenuSection
        products={products}
        subCategories={subCategories}
        handleClick={handleClick}
        handleCartClick={handleCartClick}
        cart={cart}
        setCart={setCart}
        isServerSearch={isServerSearch}
        restaurantStatus={restaurantStatus} //newly added
      />

      {/* Loading indicator for scroll pagination */}
      {isFetching && offset > 1 && (
        <div className="d-flex justify-content-center align-items-center py-4">
          <div
            className="spinner-border text-orange-500"
            role="status"
            style={{ width: "2.5rem", height: "2.5rem" }}
          >
            <span className="visually-hidden">Loading more products...</span>
          </div>
        </div>
      )}

      {/* End of results message */}
      {!isFetching && offset >= totalPages && products.length > 0 && (
        <div className="text-center py-4 text-gray-500 text-sm">
          <p>✨ You've reached the end</p>
        </div>
      )}
    </div>
  );
}

export default Product;